import { Box, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Colors from '../colors';
import PlusIconButton from '../components/PlusIconButton';
import SearchBar from '../components/SearchBar';
import ContactsAccordian from '../components/modals/ContactsAccordian';
import EditContact from '../components/modals/EditContact';
import { createNewDocInDb, deleteDocByCollectionAndId, getAllDocsInCollection, updateDocByCollectionAndId } from '../firebase';

function Contacts({ isAdmin }) {
  const [contacts, setContacts] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredContacts, setFilteredContacts] = useState(contacts);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    async function getContact() {
      const contactData = await getAllDocsInCollection('Contacts');
      setContacts(contactData)
    }
    getContact();
  }, [])


  useEffect(() => {
    const filtered = contacts.filter((contact) => {
      const nameMatches = contact.name.toLowerCase().includes(search.toLowerCase());
      const typeMatches = contact.position.toLowerCase().includes(search.toLowerCase());
      return nameMatches || typeMatches;
    });
    const departments = [...new Set(filtered.map(contact => contact.program))].sort();
    setFilteredDepartments(departments);
    setFilteredContacts(filtered);
  }, [search, contacts]);

  const handleAddContact = () => {
    setIsVisible(true)
  }

  const handleSave = async (newContactData) => {
    try {
      const newContact = await createNewDocInDb('Contacts', newContactData);
      setIsVisible(false);
      setContacts([...contacts, newContact]);
    } catch (e) {
      console.error('Error adding document: ', e);
    }
  };

  const updateContactDB = async (contact) => {
    await updateDocByCollectionAndId('Contacts', contact.id, {
      name: contact.name,
      program: contact.program,
      position: contact.position,
      officeNumber: contact.officeNumber,
      mobileNumber: contact.mobileNumber,
      comment: contact.comment
    });
  };

  const handleEditSave = (contact) => {
    const index = contacts.findIndex(
      (s) => s.id === contact.id
    );

    if (index !== -1) {
      const updatedContact = [
        ...contacts.slice(0, index),
        contact,
        ...contacts.slice(index + 1),
      ];
      setContacts(updatedContact)
      updateContactDB(contact)
      setIsVisible1(false)

    }
  }

  const deleteContactDB = async (contact) => {
    const index = contacts.findIndex(
      (s) => s.id === contact.id
    );

    if (index !== -1) {
      await deleteDocByCollectionAndId('Contacts', contact.id);
      const updatedContact = contacts.filter(s => s.id !== contact.id);
      setContacts(updatedContact)
    }
  }

  const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    paddingTop: 20,
    width: '100%',
  }

  return (
    <div style={containerStyles}>
      <SearchBar placeholder={'Search by Name or Position'} search={search} setSearch={setSearch}></SearchBar>

      {/* Display each contact by their Program/Department */}
      {filteredDepartments.map(department => {
        return (
          <React.Fragment key={department}>
            <div style={{ width: '100%', marginRight: 'auto' }}>
              <h3>{department}</h3>
              <Divider />
            </div>
            {filteredContacts.map((contact) => {
              if (contact.program === department) {
                return (
                  <ContactsAccordian
                    key={contact.id}
                    contact={contact}
                    isAdmin={isAdmin}
                    setIsVisible={setIsVisible1}
                    setSelectedContact={setSelectedContact} />
                )
              } else {
                return null;
              }
            })}
          </React.Fragment>
        )
      })}

      {isAdmin && <div>
        <Box sx={{ position: 'fixed', bottom: '20px', right: '20px' }} >
          <PlusIconButton color={Colors.blue} onClick={handleAddContact} />
        </Box>

        {isVisible && <EditContact isVisible={isVisible} setIsVisible={setIsVisible}
          onSave={handleSave}
          title={"Add New Contact"} />}

        {isVisible1 && <EditContact isVisible={isVisible1} setIsVisible={setIsVisible1} title={"Edit Contact Info"}
          contact={selectedContact} onSave={handleEditSave} onDelete={deleteContactDB} />}
      </div>}

    </div>
  )
}

export default Contacts;